module.exports = __webpack_public_path__ + "static/media/smooth-light.af4dfb66.png";